export const TOGGLE_PARKING_LOADER = 'TOGGLE_PARKING_LOADER'

export function displayParkingLoaderReducer(state = true, action) {
    switch (action.type){
        case TOGGLE_PARKING_LOADER:
            return action.payload
        default: return state
    }
}